import { createSlice, type Draft, type PayloadAction } from '@reduxjs/toolkit'
import { type ICurrentUser } from '../../constants/types/common'
import { type IOktaUser } from '../../constants/types/generatedTypesAliases'

export interface IAppState {
  user: ICurrentUser | null
  permission: boolean
  selectedUser: IOktaUser | null
  namespace: string | null
}

const initialState: IAppState = {
  user: null,
  permission: false,
  selectedUser: null,
  namespace: localStorage.getItem('namespace') ?? null,
}

export const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setUser(draft: Draft<IAppState>, { payload }: PayloadAction<ICurrentUser>) {
      draft.user = payload
    },
    setSelectedUser(draft: Draft<IAppState>, { payload }: PayloadAction<IOktaUser | null>) {
      draft.selectedUser = payload
    },
    setPermission(draft: Draft<IAppState>, { payload }: PayloadAction<boolean>) {
      draft.permission = payload
    },
    setNamespace(draft: Draft<IAppState>, { payload }: PayloadAction<string | null>) {
      draft.namespace = payload
      payload && localStorage.setItem('namespace', payload)
    },
  }
})

export const selectUser = (state) => state.appSlice.user
export const selectSelectedUser = (state) => state.appSlice.selectedUser
/* istanbul ignore next */
export const selectPermission = (state) => state.appSlice.permission
export const selectNamespace = (state) => state.appSlice.namespace

export const {
  setUser,
  setPermission,
  setSelectedUser,
  setNamespace,
} = appSlice.actions

export default appSlice.reducer
